import { API_URL } from "../../../services";
import { ReportSalesMyProductsProps } from "../reports.props";
import ReportSalesTable from "./ReportSalesTable";

// Ventas de mis productos (marca): operaciones sobre sus EANs.
const ReportSalesMyProducts: React.FC<ReportSalesMyProductsProps> = (props) => (
  <ReportSalesTable
    {...props}
    endpoint={API_URL.SALES_MY_PRODUCTS}
    allowedRoles={["brand"]}
  />
);

export default ReportSalesMyProducts;
